export default __webpack_public_path__ + "static/media/Simple_Selling_Framework_Icon.099d5d9e.svg";